import {of as observableOf,  Observable } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';
import { Injectable } from "@angular/core";

@Injectable()
export class CustomTranslationLoader implements TranslateLoader {

    getTranslation(lang: string): Observable<any> {
        const translationJson =  require('assets/i18n/'+ lang +'.js');
        return observableOf(translationJson);
    }
}